import { connect } from 'react-redux';
import styles from './ProcessValidation.module.scss';
import clsx from 'clsx';
import { DARK_MODE, N0_DATA_FOUND } from '../../constants';

const mapStateToProps = (state) => {
  return {
    themeMode: state.theme.themeMode,
  };
};

const ValidPartsDetailsPopup = ({
  parts,
  themeMode,
}) => {
  return (
    <div
      className={styles.UpcomingBox}
      style={{
        backgroundColor: themeMode === DARK_MODE ? 'black' : 'white',
        border: themeMode === DARK_MODE ? 'solid 1px #aaaaaa' : '',
      }}
    >
      <div className={styles.inner}>
        <div
          className={styles.partFamilies}
          style={{
            color: themeMode === DARK_MODE ? '#cecaca80' : '#8c888880',
            borderBottom: '1px solid #cecaca80',
          }}
        >
          <div className={styles.partFamiliesHeader}>Valid Parts</div>
        </div>

        {(!parts.length) && (
          <div
            style={{
              color: themeMode === DARK_MODE ? 'white' : 'black',
              width: '240px',
            }}
          >
            {N0_DATA_FOUND}
          </div>
        )}
        {parts?.map((item,index) => {
          return (
            <div
              className={clsx(styles.row)}
              style={{ color: themeMode === DARK_MODE ? 'white' : 'black' }}
              key={index}
            >
              <div className={styles.alignRight}>
              <strong>{item}</strong>

              </div>
            </div>
          );
        })}
      </div>

  
    </div>
  );
};

export default connect(mapStateToProps)(ValidPartsDetailsPopup);
